import { Page } from "../enums/Page";
import { animations, pixelCornersCss } from "../helpers/cssImports";
import { css, html, htmlArray } from "../helpers/webComponents";
import { LoginRegisterBaseClass } from "./LoginRegisterBaseClass";

/** CSS affecting the {@link LogoutComponent} */
const style: string = css`
.logout-btn {
    font-family: "pixel";
    position: fixed;
    background-color: rgb(15, 122, 237);
    box-shadow: -4px 0 0 0 white,
        4px 0 0 0 white,
        0 -4px 0 0 white,
        0 4px 0 0 white;
    width: 80px;
    height: 50px;
    left: 1%;
    top: 15%;
    color: white;
    font-size: 30px;
    transition: background-color 0.3s ease-in-out;
    text-shadow: 
    -2px -2px 0 black,  
    2px -2px 0 black,  
    -2px  2px 0 black,  
    2px  2px 0 black;
}

.logout-btn:hover {
    background-color: black;
    animation: hover 0.5s ease-in-out 2 forwards, glow 0.5s infinite;
}

dialog {
    background-color: rgb(15, 122, 237);
}

dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
}

dialog section {
    margin: 5%;
}

.content {
    font-size: 45px;
    font-family: "pixel";
}

.title {
    font-size: 30px;
}

h1 {
    text-shadow: 
        -4px -4px 0 white,  
        4px -4px 0 white,  
        -4px  4px 0 white,  
        4px  4px 0 white;

}

.content {
    color: white;
    text-shadow: 
        -2px -2px 0 black,  
        2px -2px 0 black,  
        -2px  2px 0 black,  
        2px  2px 0 black;
}

.btns {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
} 

dialog button {
    padding: 3%;
    margin: 2%;
    width: 50%;
    box-shadow: -5px 0 0 0 white,
    5px 0 0 0 white,
    0 -5px 0 0 white,
    0 5px 0 0 white;
    color: white;
    font-family: "pixel";
    font-size: 45px;
}

.cancel {
    background-color: rgb(15, 122, 237);
    transition: background-color 0.3s ease-in-out;

}

.confirm {
    background-color: rgb(0, 62, 129);
    transition: background-color 0.3s ease-in-out;
}

.cancel:hover, .confirm:hover {
    background-color: black;
    animation: hover 0.5s ease-in-out 2 forwards, glow 0.5s infinite;
}

${animations}
${pixelCornersCss}
`;

/**
 * Represents the logout web component
 * Handles the logout functionality
 */
export class LogoutComponent extends LoginRegisterBaseClass {
    /**
     * Constructor of the web component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    /**
     * Renders the logout btn, confirmation dialog
     * Sets up event listeners for buttons
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const logoutDialog: HTMLDialogElement = this.createLogoutDialog();
        const elements: HTMLElement[] = htmlArray`
            <style>
                ${style}
            </style>
                ${this.createLogoutBtn()}
                ${logoutDialog}
                 
        `;

        this.shadowRoot.append(...elements);
        this.setUpLogoutBtn(logoutDialog);
        this.setUpLogoutDialog(logoutDialog);
    }

    /**
     * Creates the logout btn
     * @returns - The created logout button
     */
    private createLogoutBtn(): HTMLElement {
        const element: HTMLElement = html`
            <button class="logout-btn">LOGOUT</button>
        `;
        return element;
    }

    /**
     * Creates the logout dialog
     * @returns - The created dialog
     */
    private createLogoutDialog(): HTMLDialogElement {
        const element: HTMLDialogElement = html`
        <dialog class="pixel-corners--wrapper">
            <section class="title">
                <h1>LOGOUT CONFIRMATION</h1>
            </section>
            <section class="content">
                <p>Are you sure you want to logout?</p>
            </section>
            <section class="footer">
                <div class="btns">
                    <button class="confirm">CONFIRM</button>
                    <button class="cancel">CANCEL</button>
                </div>
            </section>
        </dialog>
        ` as HTMLDialogElement;
        return element;
    }

    /**
     * Sets up the event listener for the logout button
     * @param logoutDialog - The logout dialog
     */
    private setUpLogoutBtn(logoutDialog: HTMLDialogElement): void {
        const logoutBtn: HTMLElement = this.shadowRoot?.querySelector(".logout-btn") as HTMLElement;

        logoutBtn.addEventListener("click", () => {
            logoutDialog.showModal();
        });
    }

    /**
     * Sets up the event listeners for the buttons in the logout dialog
     * Handles confirm and cancel actions
     * @param logoutDialog - The logout dialog
     */
    private setUpLogoutDialog(logoutDialog: HTMLDialogElement): void {
        const confirmBtn: HTMLElement = logoutDialog.querySelector(".confirm") as HTMLElement;
        const cancelBtn: HTMLElement = logoutDialog.querySelector(".cancel") as HTMLElement;

        cancelBtn.addEventListener("click", () => logoutDialog.close());
        confirmBtn.addEventListener("click", () => this.handleConfirmClick(logoutDialog));
    }

    /**
     * Handles the confirmation of the logout action
     * Changes login state and switch the page
     * @param logoutDialog - The logout dialog
     */
    private handleConfirmClick(logoutDialog: HTMLDialogElement): void {
        localStorage.setItem("isLoggedIn", "false");
        this.handleSwitchPage(Page.Login);
        logoutDialog.close();
    }
}
